import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, Signal } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthenticationOptions, AuthResponse, AuthTokenOptions, Profile, ProfileModel, USER_ROLES, UserModel, UserRoleEnum } from '@tsin-core/store/auth/auth.model';
import { AuthState } from '@tsin-core/store/auth/auth.state';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { BlockUIModule } from 'primeng/blockui';
import { MainHeaderComponent } from '@tsin-shared/components/main-header/main-header.component';
import { BlockGridComponent } from '@tsin-shared/components/layouts/block-grid/block-grid.component';
import { ToolbarComponent } from '@tsin-shared/components/layouts/toolbar/toolbar.component';
import { FooterComponent } from '@tsin-shared/components/footer/footer.component';
import * as CryptoJS from 'crypto-js';
import { environment } from '@tsin-env/environment';
import { buildUrl, encrypt } from '@tsin-shared/utils/route-utils';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { hasAdminRole, redirectUserToken } from '@tsin-shared/utils/user-utils';
import { MessageModule } from 'primeng/message';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-management',
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
    BlockUIModule,
    MainHeaderComponent,
    ToolbarComponent,
    BlockGridComponent,
    MessageModule,
    RouterModule,
    ToastModule,
    FooterComponent
  ],
  templateUrl: './management.component.html',
  styleUrl: './management.component.scss',
  providers: [MessageService]
})
export class ManagementComponent implements OnInit {


  USER_ROLES = USER_ROLES;
  role!: string | null;
  userProfile: Profile | null = null;
  selectedService!: string | null;

  store: Store = inject(Store);
  messageService: MessageService = inject(MessageService);

  auth: Signal<AuthResponse> = this.store.selectSignal<AuthResponse>(AuthState.getAuth);
  user: Signal<UserModel> = this.store.selectSignal<UserModel>(AuthState.getUser);
  profiles: ProfileModel[] = this.store.selectSnapshot<ProfileModel[]>(AuthState.getProfiles);

  cards = [
    {
      header: 'Exam Management',
      subheader: 'Manage Exam Assessment Programs',
      route: 'exam',
      icon: 'pi-pen-to-square',
      disabled: this.isDisabled([UserRoleEnum.EXAM_ADMIN, UserRoleEnum.ADMIN, UserRoleEnum.SUPER_ADMIN]),
    },
    {
      header: 'Learning Programs Management',
      subheader: 'Learning Admin',
      route: 'learning',
      icon: 'pi-book',
      disabled: this.isDisabled([UserRoleEnum.LEARNING_ADMIN, UserRoleEnum.SCHOOL_ADMIN, UserRoleEnum.SUPER_ADMIN]),
    },
    {
      header: 'PRO Management',
      subheader: 'Practice Ready Assessment Programs & Management',
      route: 'pro',
      icon: 'pi-clipboard',
      disabled: this.isDisabled([UserRoleEnum.PRO_ADMIN, UserRoleEnum.PRO_ADMIN_QC, UserRoleEnum.SUPER_ADMIN])
    },
    {
      header: 'User Management',
      subheader: 'Manage Users of the Portal across services',
      route: '/user-management',
      icon: 'pi-users',
      disabled: this.isDisabled([UserRoleEnum.EXAM_ADMIN, UserRoleEnum.PRO_ADMIN, UserRoleEnum.LEARNING_ADMIN, UserRoleEnum.SUPER_ADMIN])
    },
    {
      header: 'Work With Us',
      subheader: 'Work With Us Management',
      route: 'work-with-us',
      icon: 'pi-briefcase',
      disabled: this.isDisabled([UserRoleEnum.HR_ADMIN, UserRoleEnum.ADMIN, UserRoleEnum.SUPER_ADMIN]),
    }
  ];


  ngOnInit(): void {
    // this.role = this.user().role;
  }

  isDisabled(roles: UserRoleEnum[]): boolean {
    return !this.profiles.some(profile => roles.includes(profile.role));
  }

  public openServiceAdmin(item: string) {
    const adminUser = this.auth();
    this.selectedService = item;

    const token = this.auth().token!;
    const tokenEncrypted = encrypt(token);

    const refreshToken = this.auth().refreshToken!;
    const refreshTokenEncrypted = encrypt(refreshToken);

    // if(selectedProfile == undefined){
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: `No ${item.toUpperCase()} Profile`,
    //     detail: `${item.toUpperCase()} profile not found`
    //   })
    // }


    const urlPayload: AuthTokenOptions = {
      code: tokenEncrypted,
      reload: refreshTokenEncrypted,
    };
    redirectUserToken(item, urlPayload);


    // const userId = encrypt(selectedProfile!.id);
    // //redirect to sub service
    // this.redirectToSubService({
    //   examType,
    //   userId,
    //   authId
    // });
    return;
  }

  // public encrypt(password: string): string {
  //   return CryptoJS.AES.encrypt(password, environment.salt).toString();
  // }

  private redirectToSubService(urlPayload: AuthenticationOptions) {
    switch (this.selectedService) {
      case 'pro':
        const proServiceUrl = buildUrl(
          environment.proServiceUrl,
          'account/validate-login',
          {
            type: urlPayload.examType,
            auth: urlPayload.authId,
            user: urlPayload.userId
          });
        window.open(proServiceUrl, '_blank')
        return;
      case 'work-with-us':
        const workwithusServiceUrl = buildUrl(
          environment.workwithusServiceUrl,
          'account/validate-login',
          {
            type: urlPayload.examType,
            auth: urlPayload.authId,
            user: urlPayload.userId
          });
        window.open(workwithusServiceUrl, '_blank')
        return;
      case 'learning':
        const learningServiceUrl = buildUrl(
          environment.learningServiceUrl,
          'account/validate-login',
          {
            type: urlPayload.examType,
            auth: urlPayload.authId,
            user: urlPayload.userId
          }
        );
        window.open(learningServiceUrl, '_blank')
        return;
      case 'exam':
      default:
        const examServiceUrl = buildUrl(
          environment.examServiceUrl,
          'account/validate-login',
          {
            type: urlPayload.examType,
            auth: urlPayload.authId,
            user: urlPayload.userId
          }
        );
        window.open(examServiceUrl, '_blank')
        return;
    }
  }

}
